/**
 * Codes d'erreur typés remontés par les endpoints `/api/v1/audit/*`.
 * Distincts des AuthError du domain auth — les erreurs audit n'ont rien
 * d'authentification (l'authent est gérée par le middleware en amont).
 */
export type AuditErrorCode =
    | 'audit_not_configured'  // 503 — store nil au boot
    | 'invalid_filter'        // 400 — query params mal formés
    | 'missing_field'         // 400 — /aggregate sans field
    | 'missing_granularity'   // 400 — /aggregate sans granularity
    | 'internal_error'        // 500 — backend ClickHouse erreur
    | 'network_error'         // côté UI — fetch a throw (DNS/CORS)
    | 'unauthorized'          // 401 — session expirée
    | 'forbidden'             // 403 — RBAC
    | 'unknown'

export class AuditError extends Error {
    readonly code: AuditErrorCode
    readonly httpStatus: number | null

    constructor(code: AuditErrorCode, message: string, httpStatus: number | null = null) {
        super(message)
        this.code = code
        this.httpStatus = httpStatus
        this.name = 'AuditError'
    }
}

export function isAuditError(err: unknown): err is AuditError {
    return err instanceof AuditError
}

export const KNOWN_AUDIT_CODES: readonly AuditErrorCode[] = [
    'audit_not_configured',
    'invalid_filter',
    'missing_field',
    'missing_granularity',
    'internal_error',
    'network_error',
    'unauthorized',
    'forbidden',
    'unknown',
] as const
